import axios from "axios";
var BASE_URL = process.env.BASE_URL_GATEWAY || "";
var BaseService = /** @class */ (function () {
    function BaseService() {
        this._api = this.createInstance(BASE_URL);
    }
    Object.defineProperty(BaseService.prototype, "api", {
        get: function () {
            return this._api;
        },
        enumerable: false,
        configurable: true
    });
    BaseService.prototype.createInstance = function (baseURL) {
        var headers = {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Api-Key": "".concat(process.env.API_KEY_GATEWAY),
            "App-Key": "".concat(process.env.APP_KEY),
        };
        axios.defaults.baseURL = baseURL;
        var instance = axios.create({
            baseURL: baseURL,
            headers: headers,
        });
        instance.interceptors.request.use(function (config) {
            ++BaseService.activeRequests;
            return config;
        }, function (error) {
            --BaseService.activeRequests;
            return Promise.reject(error);
        });
        instance.interceptors.response.use(function (response) {
            --BaseService.activeRequests;
            return response;
        }, function (error) {
            --BaseService.activeRequests;
            return Promise.reject(error);
        });
        return instance;
    };
    BaseService.activeRequests = 0;
    return BaseService;
}());
export { BaseService };
